import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Card, Col, Input, List, Row, Select, } from "antd";
import survey from "../../actions/survey";
import { AnswerTypes } from "../../model/index";
import EditableTagGroup from "../EditableTagGroup/index";
import authActions from "../../actions/auth";

const Option = Select.Option;
const InputGroup = Input.Group;

const SelectAfter = (def, list, onChange) => {
	return (
		<Select onChange={onChange} defaultValue={def} style={{ width: 120 }}>
			{list.map((o, i) => <Option key={i} value={o}>{o}</Option>)}
		</Select>
	);
};

class Answer extends Component{
	render() {
		const {
			id, title, chain, type = AnswerTypes.Title, options,
			onChangeAnswerType, onChangeValue, onChangeChain, onChangeOptions
		} = this.props;
		return (
			<div>
				<InputGroup compact>
					<Input style={{ width: "90%" }}
					       addonAfter={SelectAfter(
						       type,
						       Object.values(AnswerTypes),
						       type => onChangeAnswerType(id, type),
					       )}
					       onChange={({ target: { value } }) => onChangeValue(id, value)}
					       value={title}/>
					<Input style={{ width: "10%" }}
					       onChange={({ target: { value } }) => onChangeChain(id,
						       value,
					       )}
					       value={chain}/>
				</InputGroup>
				<div>
					{type === AnswerTypes.Select &&
					<EditableTagGroup optionsChanged={ans => onChangeOptions(id, ans)} tags={options}/>}
				</div>
			</div>
		);
	}
}

class Step extends Component{
	constructor() {
		super();
		this.state = {
			type: null,
			title: null,
			answer: null,
			answers: null,
			addedVariants: [],
		};
	}
	
	componentWillMount() {
		var { answers, title, chain, type } = this.props;
		this.setState({
			answers, title, chain, type
		});
	}
	
	componentWillReceiveProps(nextProps) {
		var { answers, title, chain, type } = nextProps;
		this.setState({
			answers, title, chain, type
		});
	}
	
	onChangeTitle(title) {
		this.setState({
			title
		});
	}
	
	onChangeValue(key, answer) {
		var a = this.state.answers[key];
		a.title = answer;
		this.setState({
			answers: [...this.state.answers]
		});
	}
	
	onChangeChain(key, i) {
		var a = this.state.answers[key];
		a.chain = i;
		this.setState({
			answers: [...this.state.answers]
		});
	}
	
	onSubmit() {
		var { id } = this.props;
		const { answers, title, type = "radio" } = this.state;
		survey.changeStep({ id, answers, title, type });
	}
	
	isButtonDisabled() {
		// var { answers, title } = this.props;
		return false;
	}
	
	onAddVariant() {
		var { answers = [] } = this.state;
		answers.push({ title: null, chain: null });
		this.setState({
			answers
		});
	}
	
	onChangeAnswerOptions(key, options) {
		var a = this.state.answers[key];
		a.options = options;
		this.setState({
			answers: [...this.state.answers]
		});
	}
	
	onChangeAnswerType(key, type) {
		var a = this.state.answers[key];
		a.type = type;
		this.setState({
			answers: [...this.state.answers]
		});
	}
	
	onChangeType(type) {
		this.setState({
			type
		});
	}
	
	render() {
		const { id } = this.props;
		const { answers = [], title, type = "radio" } = this.state;
		return (
			<List.Item>
				<Card title={<Input
					addonBefore={`id: ${id.toString()}`}
					addonAfter={SelectAfter(type, ["radio", "single", "checkbox"],
						type => this.onChangeType(type),
					)}
					onChange={({ target: { value } }) => this.onChangeTitle(value)}
					value={title}/>}>
					{answers.map((a, i) =>
						<Answer
							onChangeOptions={this.onChangeAnswerOptions.bind(this)}
							onChangeAnswerType={this.onChangeAnswerType.bind(this)}
							onChangeValue={this.onChangeValue.bind(this)}
							onChangeChain={this.onChangeChain.bind(this)}
							key={i} {...a} id={i}/>)}
				</Card>
				<Button
					style={{ width: "50%" }}
					onClick={this.onSubmit.bind(this)}
					disabled={this.isButtonDisabled()}>Save</Button>
				<Button style={{ width: "50%" }} onClick={this.onAddVariant.bind(this)}>Add Variant</Button>
			</List.Item>
		);
	}
}

const Group = ({ answers }) => {
	return (
		<div className="EditGroup">
			{answers.map((item, i) => {
				return (<Step key={i} {...item} />);
			})}
		</div>
	);
};

class Edit extends Component{
	componentWillReceiveProps(nextProps) {
		var { steps } = nextProps;
		this.setState({
			steps
		});
	}
	
	componentWillMount() {
		var { steps } = this.props;
		this.setState({
			steps
		});
	}
	
	onAddQuestion() {
		var { steps } = this.props;
		steps.push({ id: steps.length });
		this.setState({
			steps
		});
	}
	
	handleSignOut= () => {
		authActions.signOut();
	};
	
	render() {
		const { steps } = this.state;
		return <Row type='flex' className="Edit">
			<Col xs={24} sm={16} span={8}>
				<List
					itemLayout="vertical"
					size="large"
					split={false}
					dataSource={steps}
					renderItem={item => (item.type === "group" && <Group key={item.id} {...item} />) ||
						<Step key={item.id} {...item} />}
				/>
				<Button style={{ width: "100%" }} onClick={() => this.onAddQuestion()}>Add Question</Button>
				<Button
					type="primary"
					className="login-form-button"
					onClick={this.handleSignOut}
				>
					Log out
				</Button>
			</Col>
		</Row>;
	}
}

const mapStateToProps = ({ survey: { steps } }) => {
	return {
		steps
	};
};

export default connect(mapStateToProps)(Edit);


// WEBPACK FOOTER //
// ./src/components/Edit/Edit.js